import { render, staticRenderFns } from "./SimplifyTool.vue?vue&type=template&id=22f25aef"
import script from "./SimplifyTool.vue?vue&type=script&lang=js"
export * from "./SimplifyTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports